import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { CloseIcon } from "@icarius-icons";
import {
    DialogContent,
    DialogActions,
    DialogTitle,
    Dialog,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Grid,
    TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const gridStyle = { height: 75, padding: "10px" };

const DuplicateDialog = (props) => {

    const { open, handleConfirm, handleClose, tableTypes, usedData } = props;
    const [oldType, setOldType] = useState('');
    const [oldYear, setOldYear] = useState('');
    const [type, setType] = useState('');
    const [year, setYear] = useState('');
    const dispatch = useDispatch();
    const [years, setYears] = useState({});
    const typesToUse = useMemo(() => {
        let typesToUse = [...tableTypes];
        const uniqueInUse = [...new Set(usedData?.map(item => item.data.type))];
        typesToUse = typesToUse.filter(el => uniqueInUse.includes(el.key));

        uniqueInUse.forEach((type) => {
            const index = typesToUse.findIndex(item => item.key === type);
            if (index > -1) {
                const yearsInUse = [...new Set(usedData?.filter(item => item.data.type === type).map(item => item.data.year))];
                years[type] = yearsInUse;
                setYears(years);
            }
        })

        return typesToUse;
    }, [tableTypes, usedData, years])

    const handleSubmit = () => {
        if (!oldType || !oldYear || !type || !year) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustCompleteAllValues"), severity: "warning" }));
            return;
        }
        if (Number(oldType) === Number(type) && Number(oldYear) === Number(year)) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("newRecordsCannotHaveSameTableTypeAndYearAsOriginalRecords"), severity: "warning" }));
            return;
        }

        if (year && !/(^[1-2]\d{3}$)/.test(year)) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("invalidYear"), severity: "warning" }));
            return;
        }

        handleConfirm({ oldType, oldYear, type, year });
        handleClose();
    }

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            open={open}
            scroll={"paper"}
            maxWidth={"sm"}
            fullWidth>
            <DialogTitle>
                {getLocalizedString("massiveHolidaysAndFestiveDaysDuplication")}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent style={{ paddingTop: 0 }}>
                <Grid container item xs={12}>
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel required id={`label`}>{getLocalizedString("tableType")}</InputLabel>
                            <Select
                                value={oldType}
                                labelId={`label`}
                                id={`select`}
                                onChange={(e) => setOldType(e.target.value)}
                                margin={"none"}
                            >
                                {
                                    typesToUse?.map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item.key}
                                            value={item.key}
                                        >
                                            {item.value}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel required id={`label`}>{getLocalizedString("year")}</InputLabel>
                            <Select
                                value={oldYear}
                                labelId={`label`}
                                id={`select`}
                                onChange={(e) => setOldYear(e.target.value)}
                                margin={"none"}
                            >
                                {
                                    years[oldType]?.map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel required id={`label`}>{getLocalizedString("newTableType")}</InputLabel>
                            <Select
                                value={type}
                                labelId={`label`}
                                id={`select`}
                                onChange={(e) => setType(e.target.value)}
                                margin={"none"}
                            >
                                {
                                    tableTypes?.map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item.key}
                                            value={item.key}
                                        >
                                            {item.value}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* imputation */}
                        <TextField
                            fullWidth
                            margin={"none"}
                            label={getLocalizedString("year")}
                            required
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
                <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("pollDuplication")} />
            </DialogActions>
        </Dialog>
    );
}

export default DuplicateDialog;
